import classNames from 'classnames';

import {LabelValue} from '@/types';

import './index.css';

interface LabelValueListProps {
  data?: LabelValue[];
  direction?: 'row' | 'column';
  bold?: boolean;
  colon?: boolean;
  className?: string;
  labelClassName?: string;
  valueClassName?: string;
}

const LabelValueList = (props: LabelValueListProps) => {
  const {
    direction = 'row',
    bold = true,
    colon = true,
    className,
    labelClassName,
    valueClassName,
    data = [],
  } = props;

  return (
    <div className={classNames('LabelValueList__container', className)}>
      {data.map((item, idx) => (
        <div
          key={`${idx}-${item.label}-${item.value}`}
          className={classNames(
            'LabelValueList',
            `LabelValueList--${direction}`
          )}
        >
          <span
            className={classNames(
              'LabelValueList__label',
              bold && 'LabelValueList__label--bold',
              labelClassName
            )}
          >
            {item.label}
            {colon ? ':' : ''}
          </span>
          <span
            className={classNames('LabelValueList__value', valueClassName, {
              'LabelValueList__value--bold': item.valueBold,
            })}
          >
            {item.value}
          </span>
        </div>
      ))}
    </div>
  );
};

export default LabelValueList;
